import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { PortalBuilderService } from 'src/app/shared/services/administratior-service/portal-builder.service';
import { SearchPaymentService } from 'src/app/shared/services/search-payment-service/search-payment.service';
import { UserService } from 'src/app/shared/services/user-services/user.service';
import saveAs from 'file-saver';
import { formatDate } from '@angular/common';
import { WalletManagmentService } from 'src/app/shared/services/wallet-service/wallet-managment.service';
import { ConfiguratorService } from 'src/app/shared/services/configurator-service/configurator.service';
@Component({
  selector: 'app-search-payment',
  templateUrl: './search-payment.component.html',
  styleUrls: ['./search-payment.component.css'],
})
export class SearchPaymentComponent implements OnInit {
  paymentList: any;
  paginationLimit = 0;
  paginationCurrentPage = 1;
  paginationTotalData = 0;
  paginationTotalPage = 0;
  searchForm!: FormGroup;
  currencylist: any;
  merchantList: any;
  provider: any = [];

  //

  constructor(
    private PaymentService: SearchPaymentService,
    private fb: FormBuilder,
    private schemeService: ConfiguratorService,
    private PortalBuilder: PortalBuilderService,
    private userService: UserService
  ) {}
  pagination = {
    limit: 10,
    currentPage: 1,
  };
  currentDate = new Date();

  cValue = formatDate(this.currentDate, 'yyyy-MM-dd', 'en-US');
  paginationMerchant = {
    limit: 10000,
    currentPage: 1,
  };

  keyPressNumbers(event: any) {
    var charCode = event.which ? event.which : event.keyCode;
    // Only Numbers 0-9
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }
  ngOnInit(): void {
    this.searchForm = this.fb.group({
      PGREFNO: [''],
      ORDERID: [''],
      UTR: [''],
      STATUS: [''],
      TRANSATIONMODE: [''],
      MERCHANTID: [''],
      ACQID: [''],
      CUSTOMEREMAIL: [''],
      PAYMENTTYPE: [''],
      MOPTYPE: [''],
      TXNTYPE: [''],
      STARTDATE: [''],
      ENDDATE: [new Date().toISOString().split('T')[0]],
      CURRENCYCODE: [''],
    });
    this.getPaymentListing(this.pagination);
    this.getCurrency();
    this.getMerchant(this.paginationMerchant);
    this.getProviders('');
  }
  getProviders(type: any) {
    let pagination = {
      limit: 1000,
      currentPage: 1,
    };
    this.schemeService
      .getAllProviderWithPagination(pagination, type, '')
      .subscribe({
        next: (response: any) => {
          this.provider = response.data.data;
        },
        error: (error: any) => {
          console.error('Error  Creating state:', error);
        },
        complete: () => {
          console.log('Create request completed');
        },
      });
  }
  getPaymentListing(payload: any) {
    let mergedObject = Object.assign({}, payload, this.searchForm?.value);

    // mergedObject.STARTDATE = mergedObject.STARTDATE ? formatDate(
    //   mergedObject.STARTDATE,
    //   'dd-MM-yyyy',
    //   'en-US'
    // ): '';
    // mergedObject.ENDDATE = mergedObject.ENDDATE ? formatDate(
    //   mergedObject.ENDDATE,
    //   'dd-MM-yyyy',
    //   'en-US'
    // ) : '';
    console.log(mergedObject);
    this.PaymentService.getPayementListing(mergedObject).subscribe((res) => {
      this.paymentList = res?.data?.data;
      this.paginationLimit = res.data.limit;
      this.paginationCurrentPage = res.data.currentPage;
      this.paginationTotalData = res.data.totalData;
      this.paginationTotalPage = res.data.totalPage;
    });
  }

  exportCSV() {
    const mergedObject = Object.assign(
      {},
      this.pagination,
      this.searchForm?.value
    );
    console.log(mergedObject);
    this.PaymentService.exportCSV(mergedObject).subscribe((res) => {
      console.log(res);
      saveAs(res, `file.csv`);
    });
  }

  nextPage() {
    this.pagination.currentPage++;
    this.paginationCurrentPage++;
    this.getPaymentListing(this.pagination);
  }

  // Method to handle previous page
  previousPage() {
    if (this.pagination.currentPage > 1) {
      this.pagination.currentPage--;
      this.paginationCurrentPage--;
      this.getPaymentListing(this.pagination);
    }
  }

  onLast() {
    this.pagination.currentPage = this.paginationTotalPage;
    this.getPaymentListing(this.pagination);
  }
  onFirst() {
    this.pagination.currentPage = 1;
    this.getPaymentListing(this.pagination);
  }

  onPageChange(page: any) {
    this.pagination.currentPage = page;
    this.getPaymentListing(this.pagination);
  }

  getCurrency() {
    this.PortalBuilder.GetCurrency().subscribe((res) => {
      this.currencylist = res?.data?.data;
    });
  }
  getMerchant(paginationMerchant: any) {
    this.userService
      .getUsersWithPagination2({ ...paginationMerchant, type: 'merchant',sort:"name" })
      .subscribe({
        next: (res) => {
          this.merchantList = res?.data?.data;
       
       
         
        },
        error: (err) => console.error(err),
        complete: () => console.log('Observable complete'),
      });
  }
  

}
